import { useTheme } from '@mui/joy/styles'
import useMediaQuery from '@mui/system/useMediaQuery'

export const useIsMobile = (): boolean => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('md'))
}
